import { useEffect } from 'react';

const Redirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.assign(to);
  }, [to]);

  return null;
};

export default Redirect;
